var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("p", [
        _vm._v(
          "Your payment failed. An updated payment is required to proceed with your promotion request."
        )
      ]),
      _c("payment-gateway", {
        ref: "paymentGateway",
        attrs: {
          profile: _vm.SessionProfile
        },
        on: {
          "card-switch": _vm.cardSwitch,
          card: _vm.setCard
        }
      }),
      _c(
        "gg-btn",
        {
          attrs: {
            color: "primary",
            tile: "",
            loading: _vm.loading
          },
          on: {
            click: _vm.pay
          }
        },
        [_vm._v("Pay")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }